import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
// import logger from 'redux-logger'
import reducers from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore(preloadedState) {
	return createStore(
		reducers,
		preloadedState,
		REACT_APP_PROD && composeEnhancers(applyMiddleware(thunkMiddleware)) ||
		composeEnhancers(
			applyMiddleware(thunkMiddleware),
			// applyMiddleware(logger), // 默认关闭，需要时开启 wh 2019.8.1
		)
	)
}